module.exports = __webpack_public_path__ + "static/media/13d.9e4ec872.svg";